<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="520"
    persistent
  >
    <v-card>
      <v-toolbar
        dense
        light
        class="grey lighten-3"
      >
        <v-toolbar-title class="text-body-1 font-weight-bold">
          {{ $t('m.vessel') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          color=""
          @click="handleAdd"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          icon
          color=""
          @click="handleCancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-progress-linear
          :active="isLoading"
          :indeterminate="isLoading"
          absolute
          bottom
          color="deep-purple accent-4"
        />
      </v-toolbar>
      <v-divider />

      <v-card
        flat
        tile
        class=""
        style="height:520px; overflow-y:auto;"
      >
        <template v-if="items.length>0">
          <v-list
            dense
            class="mx-2 my-1"
          >
            <v-list-item-group
              v-model="selectedItem"
              color="primary"
            >
              <template v-for="(item, index) in items">
                <v-list-item class="px-2">
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-body-2"
                      v-text="item.SHIPNAME"
                    />
                  </v-list-item-content>
                  <v-list-item-action class="d-inline-block">
                    <v-btn
                      icon
                      color="grey"
                      @click="confirmDel(item.SHIPID, index)"
                    >
                      <v-icon small>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      class="ml-2"
                      @click="handleEdit(item.SHIPID, index)"
                    >
                      <v-icon small>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index<items.length-1" />
              </template>
            </v-list-item-group>
          </v-list>
        </template>
        <template v-if="items.length==0 && !isLoading">
          <v-card
            flat
            tile
            class="text-center mt-16"
            style=""
          >
            {{ $t('m.noRecord') }}
            <v-btn
              class="ml-4"
              small
              depressed
              color="primary"
              @click="handleAdd"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              Add
            </v-btn>
          </v-card>
        </template>
      </v-card>
    </v-card> <!-- end 最外层 card -->

    <v-dialog
      v-model="delConfirmDialog"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title class="text-subtitle-2">
          {{ $t('m.deleteVessel') }}
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey darken-2"
            text
            @click="delConfirmDialog = false"
          >
            {{ $t('m.cancel') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="del"
          >
            {{ $t('m.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ShipInfoEditDialog
      :visible="editDlgVisible"
      :ship-i-d="currId"
      :view-flag="viewFlag"
      @save="handleAfterSave"
      @cancel="cancelEdit"
    />

    <!-- <v-overlay :value="overlay"></v-overlay> -->
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import dayjs from 'dayjs'
import ShipInfoEditDialog from '@/views/ShipInfoEditDialog'

export default {
  name: 'ShipInfoListDialog',
  components: {
    ShipInfoEditDialog
  },
  props: [
    'visible'
  ],
  data () {
    return {
      dialog: false,
      selectedItem: null,
      editDlgVisible: false,

      overlay: false,
      isLoading: false,
      delConfirmDialog: false,
      items: [],

      viewFlag: null,
      currId: null,
      currIndex: null
    }
  },
  computed: {
    ...mapState({
      userLogoutClearFlag: state => state.user.userLogoutClearFlag
    })

  },
  watch: {
    visible: function (val) {
      this.dialog = val
      this.query()
    },

    userLogoutClearFlag: function (val) {
      if (val) {
        this.items = []
      }
    }
  },
  created () {
    this.$store.commit('resetVesselFormEmpty')
  },

  methods: {
    handleDrawer () {
      this.$store.commit('setDrawer', true)
    },

    query () {
      this.isLoading = true
      this.overlay = true
      var json = {
        OperID: Utils.getWithExpiry('operID'),
        QryParticular: true
      }
      httpClient.post('/SIShipSimpleInfoQry', json)
        .then((res) => {
          this.isLoading = false
          this.overlay = false
          this.items = res.data
        }).catch((err) => {
          this.isLoading = false
          this.overlay = false
        })
    },

    confirmDel (id, index) {
      this.delConfirmDialog = true
      this.currId = id
      this.currIndex = index
    },

    del () {
      this.delConfirmDialog = false
      this.isLoading = true
      console.log(this.currId)
      var json = {
        OperID: Utils.getWithExpiry('operID'),
        ShipID: this.currId
      }
      httpClient.post('/SIShipInfoDel', json)
        .then((res) => {
          console.log(res)
          this.isLoading = false
          this.items.splice(this.currIndex, 1)
          this.currId = null
          this.currIndex = null
        }).catch((err) => {
          console.log(err)
          this.isLoading = false
        })
    },

    handleCancel () {
      this.dialog = false
      this.$emit('cancel')
    },

    handleAdd () {
      this.currId = null
      this.editDlgVisible = true
    },

    handleEdit (shipID, index) {
      this.currId = shipID
      this.editDlgVisible = true
    },
    handleView (shipID, index) {
      this.$router.push({
        path: '/home/ship-edit',
        query: { shipID: shipID, viewFlag: 'VIEW' }
      })
    },
    handleAfterSave () {
      this.query()
      this.editDlgVisible = false
    },
    cancelEdit () {
      this.editDlgVisible = false
    }

  },
  filters: {
    timFormat: function (val) {
      if (!val) return ''
      return dayjs(val).format('YYYY/MM/D HH:mm')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
